export default __webpack_public_path__ + "static/media/contact-background2.2791a222.jpg";